import { useQuery } from 'react-query'
import request from '../../request'
import { Dealership } from '../../../lib/types/Dealership'
import { useDealership } from '../../../store/zustand/dealershipStore'
import { VendorAccounts } from './useEditDealership'

export const useGetDealershipById = (id?: string) => {
  const dealership = useDealership()
  return useQuery(
    ['agency', dealership?.organization_id, 'dealership', id],
    ({ signal }) =>
      request<
        Dealership & {
          vendorAccounts: Array<{
            _id: number
            accounts: Array<Record<string, string | number>>
          }>
        }
      >({
        url: `/agencies/${dealership?.organization_id}/dealership/${id}`,
        method: 'GET',
        signal,
      }),
    {
      enabled: !!id,
    },
  )
}
